import { useTranslation } from "react-i18next";

import { Button } from "../design-system/Button";
import { StatusBanner } from "../design-system/StatusBanner";
import {
  applyServiceWorkerUpdate,
  dismissOfflineReady,
  useServiceWorkerStatus,
} from "../service-worker/registration";

export function PwaStatusBanner() {
  const { t } = useTranslation("foundation");
  const { needRefresh, offlineReady } = useServiceWorkerStatus();
  const hasNotice = needRefresh || offlineReady;

  /*
   * The region is mounted from the first render, before there is anything to
   * announce. Returning null until the service worker reported in inserted the
   * live region already populated, which screen readers generally do not
   * announce -- so the update prompt, and its action, could go unheard.
   */
  return (
    <StatusBanner
      action={
        hasNotice ? (
          <Button
            variant="quiet"
            onClick={() => {
              if (needRefresh) {
                void applyServiceWorkerUpdate();
              } else {
                dismissOfflineReady();
              }
            }}
          >
            {needRefresh ? t("shell.updateAction") : t("shell.dismiss")}
          </Button>
        ) : undefined
      }
      label={t("shell.systemStatusLabel")}
      title={
        needRefresh ? t("shell.updateAvailable") : offlineReady ? t("shell.offlineReady") : null
      }
    />
  );
}
